export const fieldCannotBeEmpty = 'This field is required'
export const maxLengthName = 'The name is too long. Max length is 120 characters.'
export const maxLength = 'Max length is 4 characters.'
export const minLength = 'Min length is 4 characters.'
export const otpCodeWasSent = 'OTP code has been sent'
export const themeEdited = 'Theme changed successfully'
export const incorrectCode = 'Incorrect Code'
export const maxLengthTextarea = 'Max length is 500 characters.'
export const emailIsNotCorrect = 'Please enter a enabled email address.'
// VERA-1095: this message previously described a DIFFERENT, looser rule than
// the regex it was paired with (`passwordRex` in constants/regex.ts) actually
// enforced. Now imports the one prose description of the real policy —
// see constants/passwordPolicy.ts — so the message and the rule it's
// attached to can't drift apart again.
export { PASSWORD_POLICY_HELP_TEXT as passwordValidationText } from './passwordPolicy'

export const MAX_LENGTH = (field: string, length: number) => `${field} cannot be more than ${length} characters.`
export const MIN_LENGTH = (field: string, length: number) => `${field} cannot be less than ${length} characters.`
